import { render, staticRenderFns } from "./CompaniesTable.vue?vue&type=template&id=6f0e3df3&scoped=true&"
import script from "./CompaniesTable.vue?vue&type=script&lang=js&"
export * from "./CompaniesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e3df3",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/CompaniesTable.vue
// module id = null
// module chunks = 